'use client';
import cn from 'classnames';

import { trackContentfulClick, trackGlobalPromoBanner } from '@libs/analytics';
import { Banner, TextPassage } from '@petsmart-ui/sparky';
import { usePathname } from 'next/navigation';
import type { SiteWidePromoBannerProps } from './types';
import './SiteWidePromoBanner.scss';

export default function SiteWidePromoBanner({
    text,
    link,
    backgroundColor,
}: Readonly<SiteWidePromoBannerProps>) {
    const pathname = usePathname();
    if (!text) {
        return null;
    }
    const cta = link ? <a href={link.webUrl}>{text}</a> : text;
    return (
        <Banner
            onClick={() => {
                trackGlobalPromoBanner(text);
                trackContentfulClick({
                    linkText: text ?? '',
                    linkUrl: link?.webUrl ?? '',
                    promoTitle: text ?? '',
                    promoVariant: 'site wide promo banner',
                    promoOrigin: pathname,
                    promoDesc: text ?? '',
                    promoType: 'site wide promo banner',
                });
            }}
            className={cn('sitewide-promo', {
                'sitewide-promo__red': backgroundColor === 'Red',
                'sitewide-promo__blue': backgroundColor === 'Blue',
                'sitewide-promo__vipp': backgroundColor === 'VIPP',
            })}
            data-testid="sitewide-promo"
        >
            <TextPassage align="center">
                <p>{cta}</p>
            </TextPassage>
        </Banner>
    );
}
